// src/pages/RegisterChild.js
import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { darken } from "@mui/material/styles";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  updateDoc,
  arrayUnion,
  Timestamp,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const RegisterChild = () => {
  const { user } = useAuth();
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!name || !gender || !birthDate) return;

    setLoading(true);
    setError("");

    try {
      const newChildRef = doc(collection(db, "children"));

      await setDoc(newChildRef, {
        name,
        gender,
        birthDate,
        createdBy: user.email,
        access: [user.email],
        created: new Date().toISOString(),
      });

      await updateDoc(doc(db, "users", user.uid), {
        children: arrayUnion(newChildRef.id),
      });

      navigate("/tracker/" + newChildRef.id);
    } catch (err) {
      console.error("Error registering child:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{ mt: 10 }}
    >
      <Typography
        variant="h4"
        align="center"
        gutterBottom
      >
        Register your child
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          mt: 4,
          backgroundColor: "#fefad4",
          padding: 4,
          borderRadius: 2,
          boxShadow: 0,
        }}
      >
        <TextField
          label="Child's name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          autoFocus
          autoComplete="name"
        />
        <FormControl fullWidth>
          <InputLabel>Gender</InputLabel>
          <Select
            value={gender}
            label="Gender"
            onChange={(e) => setGender(e.target.value)}
          >
            <MenuItem value="boy">Boy</MenuItem>
            <MenuItem value="girl">Girl</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Birth Date"
          type="date"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!name || !gender || !birthDate || loading}
          sx={{
            backgroundColor: darken("#fefad4", 0.2),
            "&:hover": {
              backgroundColor: darken("#fefad4", 0.3),
            },
          }}
        >
          {loading ? "Saving..." : "Save and continue"}
        </Button>
      </Box>
    </Container>
  );
};

export default RegisterChild;
